/*@flow*/
import type { Node } from 'react';
import React from 'react';
import FreeModal from 'comps/FreeModal';
import ResourceBuilder from './';
import useCommands from './useCommands';
import useContextState from './useContextState';

type PropsT = { isOpen?: boolean, onClose?: Function };

function Modal(props: PropsT): Node {
  const s = useContextState();
  const cmd = useCommands();
  const showModal = Boolean(s.portalMode === 'OPEN' || props.isOpen);

  const closeNow = () => {
    cmd.close();
    props.onClose && props.onClose();
  };
  let requestClosePortal = closeNow;
  let requestClosePortal2 = closeNow;
  const { mode, mutated } = s;

  if (mode === 'RESOURCE_FORM' || mode === 'WIZARD_FORM') {
    requestClosePortal = () => {
      if (mutated) {
        cmd.close({ confirm: true });
      } else {
        cmd.close();
      }
      props.onClose && props.onClose();
    };
    requestClosePortal2 = (doForce) => {
      if (doForce && mutated) {
        cmd.close({ confirm: true });
      } else {
        cmd.close();
      }
      props.onClose && props.onClose();
    };
  }

  return (
    <FreeModal
      id="resourceFormModal"
      isOpen={showModal}
      requestClosePortal={requestClosePortal}
    >
      <ResourceBuilder requestClosePortal={requestClosePortal2} />
    </FreeModal>
  );
}

export default Modal;
